import { render, staticRenderFns } from "./ModalUnsuppressAsset.vue?vue&type=template&id=3906e84a"
import script from "./ModalUnsuppressAsset.vue?vue&type=script&lang=js"
export * from "./ModalUnsuppressAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports